import { CodesReport } from './CodesReport';

export default CodesReport;
